import { helper } from '@ember/component/helper';
import { numberToUserDisplay } from '@ebiz/pretty-num';

export default helper(function engnum(
  [num],
  { digits = 3, showZeroes = false, supplySpace = false }: UserDisplayOptions,
) {
  return numberToUserDisplay(num as number, 'Engineering', digits, {
    showZeroes: showZeroes,
    supplySpace: supplySpace,
  });
});
